export default __webpack_public_path__ + "static/media/menuInfo.38b020b4.svg";